//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'search_shop_config',
  props: {
    disabled: Boolean,
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  }
};